import React from 'react';
import { Typography } from "src/latest/src/components";

interface Prop {
  keyName?: string;
  valueName: string;
}

const EventTooltipDetail: React.FC<Prop> = ({ keyName, valueName }) => {

  return (
    <div>
      {keyName && <Typography variant='size-14'>
        <div className='d-flex'>
          <div className='comman-width'>
            <Typography variant='size-14' color='color-28'>{valueName}</Typography>
          </div>
          <div className='ms-3'>
            <Typography variant='size-14' weight='semi-bold' color='color-2'>
              {keyName}
            </Typography>
          </div>
        </div>
      </Typography>
      }

    </div>
  );
};

export default EventTooltipDetail;